import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import localStorageService from "../../services/localStorage.service"
import userService from "../../services/user.service"
import { pickUserProfile } from "../../hooks/useApiQueries"
import { hasChatsAccess } from "../../utils/chatsAccess"
import dictionary from "../../utils/dictionary"
import ContainerBox from "../ui/containerBox"
import PageLoadingShell from "../ui/pageLoadingShell"

const CrmChatsRoute = ({ children }) => {
  const selectedLanguage = useSelector((state) => state.lang.lang)
  const [ready, setReady] = useState(false)
  const [allowed, setAllowed] = useState(false)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      let profile = localStorageService.getUserProfile()
      if (!profile) {
        const user = await userService.getUserById(
          localStorageService.getUserId()
        )
        if (user) {
          profile = pickUserProfile(user)
          localStorageService.setUserProfile(profile)
        }
      }
      if (cancelled) return
      setAllowed(hasChatsAccess(profile))
      setReady(true)
    }
    load()
    return () => {
      cancelled = true
    }
  }, [])

  if (!ready) return <PageLoadingShell />
  if (!allowed) {
    return (
      <div className="container-fluid relative mx-auto min-h-screen pb-[32px] flex justify-center items-start bg-cream max-md:text-sm">
        <ContainerBox>
          <p className="text-brown">
            {dictionary[selectedLanguage].chatsAccessDenied ||
              "Нет доступа"}
          </p>
        </ContainerBox>
      </div>
    )
  }
  return children
}

CrmChatsRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

export default CrmChatsRoute
